<template>
  <div
    class="color-selector"
    :class="{ 'color-selector--all-genders': isShowingAllGenders }"
    @mouseover="onMouseevent(true)"
    @mouseleave="onMouseevent(false)"
  >
    <div class="color-selector__gender" v-show="isShowingAllGenders && maleVariants.length > 0">
      {{ $t('filter.gender_male') }}
    </div>

    <template v-if="isShowingAllGenders || genderToShow === GENDERS.mens">
      <ColorBox
        v-for="(variant, index) in maleVariants"
        :variant="variant"
        :key="'m-' + index"
        :onColorSelect="onColorSelect"
        :currentVariantId="currentVariantId"
      />
    </template>
    <div class="color-selector__gender" v-show="isShowingAllGenders && femaleVariants.length > 0">
      {{ $t('filter.gender_female') }}
    </div>
    <template v-if="isShowingAllGenders || genderToShow === GENDERS.womens">
      <ColorBox
        v-for="(variant, index) in femaleVariants"
        :variant="variant"
        :key="'f-' + index"
        :onColorSelect="onColorSelect"
        :currentVariantId="currentVariantId"
      />
    </template>
    <div class="color-selector__gender" v-show="isShowingAllGenders && unisexVariants.length > 0">
      {{ $t('filter.all_genders') }}
    </div>
    <template v-if="isShowingAllGenders || unisexVariants.length > 0">
      <ColorBox
        v-for="(variant, index) in unisexVariants"
        :variant="variant"
        :key="'u-' + index"
        :onColorSelect="onColorSelect"
        :currentVariantId="currentVariantId"
      />
    </template>
  </div>
</template>

<script>
import { GENDERS } from '@/stores/product'
import ColorBox from './ColorBox.vue'

export default {
  name: 'ColorSelector',
  components: { ColorBox },

  props: {
    genderToShow: {
      type: String,
      validator(value) {
        return !value || Object.values(GENDERS).includes(value)
      },
    },

    variants: {
      type: Array,
      required: true,
    },

    currentVariantId: {
      type: Number,
      required: true,
    },

    onColorSelect: {
      type: Function,
      required: true,
    },

    onMouseevent: {
      type: Function,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      GENDERS,
      maleVariants: [],
      femaleVariants: [],
      unisexVariants: [],
    }
  },

  computed: {
    isShowingAllGenders() {
      return !this.genderToShow
    },
  },

  created() {
    this.separateGenderVariants()
  },

  methods: {
    separateGenderVariants() {
      this.variants.forEach(variant => {
        if (variant.gender.length === 1) {
          variant.gender.some(v => ['mens', 'men'].includes(v))
            ? this.maleVariants.push(variant)
            : this.femaleVariants.push(variant)
        } else {
          // Unisex variants contain both "mens" and "womens" gender
          this.unisexVariants.push(variant)
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import './ColorSelector';
</style>
